import axios from "axios";
import router from "@/router";

const authToken = () => {
	return "Bearer " + localStorage.getItem("token")
}
const contentType = {
	json: "application/json",
	form: "application/x-www-form-urlencoded",
	multipart: "multipart/form-data"
}

const get = async (url, query = null, auth = true) => {
	try {
		return await axios.get(url, {
			headers: {
				"Authorization": auth ? authToken() : null,
			},
			params: query,
		})
	} catch (e) {
		return handleErrorNetwork(e)
	}
}

const post = async (url, data, contentType, query = null, auth = true) => {
	try {
		return await axios.post(url, data, {
			headers: {
				"Authorization": auth ? authToken() : null,
				contentType: contentType,
			},
			params: query,
		})
	} catch (e) {
		return handleErrorNetwork(e)
	}
}

const patch = async (url, data, contentType, query = null, auth = true) => {
	try {
		return await axios.patch(url, data, {
			headers: {
				"Authorization": auth ? authToken() : null,
				contentType: contentType,
			},
			params: query,
		})
	} catch (e) {
		return handleErrorNetwork(e)
	}
}

const del = async (url, data, contentType, auth = true) => {
	try {
		return await axios.delete(url, {
			headers: {
				"Authorization": auth ? authToken() : null,
				contentType: contentType,
			},
			params: data,
		})
	} catch (e) {
		return handleErrorNetwork(e)
	}
}

const handleErrorNetwork = (e) => {
	if (e.response) {
		let err = "";
		switch (e.response.status) {
			case 404:
				err = "Terjadi kesalahan, URL tidak ditemukan"
				break;
			case 401:
				err = "Terjadi kesalahan, gagal melakukan autentikasi"
				break;
			case 500:
				if (e.response.data) {
					err = e.response.data.msg
				} else {
					err = "Terjadi kesalahan, mohon periksa koneksi internet Anda atau coba lagi nanti. Lebih lanjut hubungi cs kami di nomor 6285234494494 [error: " + e.response.status + "]"
				}
				break;
			case 400:
				if (e.response.data) {
					err = e.response.data.msg
				} else {
					err = "Terjadi kesalahan, mohon periksa koneksi internet Anda atau coba lagi nanti. Lebih lanjut hubungi cs kami di nomor 6285234494494 [error: " + e.response.status + "]"
				}
				break;
			default:
				if (e.response.data) {
					err = e.response.data.msg
				} else {
					err = "Terjadi kesalahan, mohon periksa koneksi internet Anda atau coba lagi nanti. Lebih lanjut hubungi cs kami di nomor 6285234494494 [error: " + e.response.status + "]"
				}
				break;
		}
		return err
	} else if (e.request) {
		return "Terjadi kesalahan, mohon periksa koneksi internet Anda atau coba lagi nanti. Lebih lanjut hubungi cs kami di nomor 6285234494494 [error: request]"
	} else {
		// return e
		return "Terjadi kesalahan, mohon periksa koneksi internet Anda atau coba lagi nanti. Lebih lanjut hubungi cs kami di nomor 6285234494494"
	}
}

const queryStringToObject = (query) => {
	const params = new URLSearchParams(query);
	const obj = {};

	for (const key of params.keys()) {
		if (params.getAll(key).length > 1) {
			obj[key] = params.getAll(key);
		} else {
			if (key === "key") {
				obj[key] = params.get(key)
			} else {
				obj[key] = isNaN(params.get(key)) ? params.get(key) : Number(params.get(key));
			}
		}
	}
	return obj
}

const setQueryString = async (query) => {
	for (let key in query) {
		if (Array.isArray(query[key]) && query[key].length === 1) {
			query[key] = isNaN(query[key][0]) ? query[key][0] : Number(query[key][0]);
		}
	}
	let compareObjQuery = queryStringToObject(window.location.search)
	if (JSON.stringify(query) !== JSON.stringify(compareObjQuery)) {
		await router.replace({query: query})
	}
}

const conn = {
	get,
	post,
	del,
	patch,
	contentType,
	queryStringToObject,
	setQueryString,
}

export default conn